module.exports = __webpack_public_path__ + "static/media/flutter.80bad728.svg";